import { render, staticRenderFns } from "./ResellerProductViewLogs.vue?vue&type=template&id=e4481f66"
import script from "./ResellerProductViewLogs.vue?vue&type=script&lang=js"
export * from "./ResellerProductViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports